import useIsMobile from '../../utils/windows';
import styles from '../Simulation.module.css';

const FLOORS = ['B2', 'B1', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16'];
const Z_LEVELS = [-6.5, -3.9, 0.0, 3.6, 6.9, 10.2, 13.5, 16.8, 20.1, 23.4, 26.7, 30.0, 33.3, 36.6, 39.9, 43.2, 46.5, 49.8];

export function ziFromFloor(floor) {
    if (floor === 'B2') return 0;
    if (floor === 'B1') return 1;
    return parseInt(floor, 10) + 1;
}

export function qiFromMetric(metric) {
    if (metric === 'vis') return 2;
    if (metric === 'temp') return 1;
    return 0;
}

export default function FloorPicker({ value, metric, simulationId, onChange, send, allowedFloors }) {
    const isMobile = useIsMobile();
    const hasLimit = Array.isArray(allowedFloors) && allowedFloors.length > 0;

    // 👇 모바일이면 역순, 아니면 원래 순서
    const floorsToRender = isMobile ? FLOORS : FLOORS.slice().reverse();
    return (
        <div className={styles.floorpicker}>
            {floorsToRender.map((f) => {
                const isActive = value === f;
                const isDisabled = hasLimit && !allowedFloors.includes(f);

                return (
                    <button
                        key={f}
                        className={`${styles.btn} ${styles.btnSm} ${styles.floorpickerBtn} ` + (isActive ? styles.btnActive : '')}
                        disabled={isDisabled}
                        onClick={() => {
                            if (isDisabled) return; // 제한된 층은 클릭 무시

                            onChange(f);

                            if (simulationId) {
                                const zi = ziFromFloor(f);
                                const qi = qiFromMetric(metric);
                                send({ action: 'change_contour', simulationId, zi, qi });
                            }
                        }}
                    >
                        {f}층
                    </button>
                );
            })}
        </div>
    );
}
